import React from 'react';

export const NoRecordIcon = () => (
  <svg height="248" viewBox="0 0 255 248" width="255" xmlns="http://www.w3.org/2000/svg">
    <g data-name="Group 3916" id="Group_3916" transform="translate(-749 -239)">
      <g data-name="Group 3495" id="Group_3495" transform="translate(749 239)">
        <ellipse cx="127.5" cy="124" data-name="Ellipse 16" fill="#f8f8f8" id="Ellipse_16" rx="127.5" ry="124" />
      </g>
    </g>
    <path
      d="M133.187,343.561H116.594A16.589,16.589,0,0,1,100,326.968V260.594A16.589,16.589,0,0,1,116.594,244h66.374a16.589,16.589,0,0,1,16.594,16.594v16.594m-49.781,99.561h66.374a16.589,16.589,0,0,0,16.594-16.593V293.781a16.589,16.589,0,0,0-16.594-16.594H149.781a16.589,16.589,0,0,0-16.594,16.594v66.374A16.589,16.589,0,0,0,149.781,376.748Z"
      data-name="Path 593"
      fill="none"
      id="Path_593"
      stroke="#0a3256"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
      transform="translate(-39 -186.311)"
    />
    <path
      d="M148,150h62.13M148,167.233h62.13m-27.182,17.233H210.13"
      data-name="Path 606"
      fill="none"
      id="Path_606"
      stroke="#0a3256"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      transform="translate(-32.801 -17)"
    />
    <path
      d="M26.615,6.5A2.216,2.216,0,0,0,24.508,5H8.192A2.231,2.231,0,0,0,6.085,6.5L3,15.383V27.25a1.488,1.488,0,0,0,1.483,1.483H5.967A1.488,1.488,0,0,0,7.45,27.25V25.767h17.8V27.25a1.488,1.488,0,0,0,1.483,1.483h1.483A1.488,1.488,0,0,0,29.7,27.25V15.383ZM8.192,21.317a2.225,2.225,0,1,1,2.225-2.225A2.222,2.222,0,0,1,8.192,21.317Zm16.317,0a2.225,2.225,0,1,1,2.225-2.225A2.222,2.222,0,0,1,24.508,21.317ZM5.967,13.9,8.192,7.225H24.508L26.733,13.9Z"
      fill="none"
      id="ic_directions_car_24px"
      stroke="#0a3256"
      strokeWidth="1.5"
      transform="translate(103.5 94)"
    />
    <g id="moto" transform="translate(16.117 66.264)">
      <g id="svg_4" transform="translate(66.12 12.408)">
        <g id="svg_5">
          <rect fill="#0a3256" height="1.819" id="svg_6" width="6.094" />
        </g>
      </g>
      <g id="svg_7" transform="translate(56 0)">
        <g id="svg_8">
          <path
            d="M81.895,0H78.442a.508.508,0,0,0-.575.49v.637l-2.532.833a.534.534,0,0,0-.345.49V4.411H72.055a4.5,4.5,0,0,0-5.639,0H63.481V2.451a.435.435,0,0,0-.345-.441L60.6,1.127V.49A.508.508,0,0,0,60.028,0H56.575A.508.508,0,0,0,56,.49V2.451a.508.508,0,0,0,.575.49h3.453a.508.508,0,0,0,.575-.49V2.206l1.726.588V4.411h-.575a.508.508,0,0,0-.575.49v.49H57.726v.98h3.453v.49a.5.5,0,0,0,.46.49l3.8.637a3.753,3.753,0,0,0,.978,1.323H65.149c-2.532,0-4.546,1.764-4.546,3.872V23.477a2.214,2.214,0,0,0,2.359,2.01h2.82v.98a3.5,3.5,0,0,0,6.905,0v-.98h2.82a2.217,2.217,0,0,0,2.359-2.01V13.185c0-2.157-2.072-3.872-4.546-3.872H72.055a3.166,3.166,0,0,0,.978-1.323l3.8-.637a.5.5,0,0,0,.46-.49v-.49h3.453v-.98H77.291V4.9a.508.508,0,0,0-.575-.49H76.14V2.794l1.726-.588v.245a.508.508,0,0,0,.575.49h3.453a.508.508,0,0,0,.575-.49V.49A.508.508,0,0,0,81.895,0ZM59.453,1.961h-2.3V.98h2.3Zm5.754,4.9v.1L62.33,6.47V5.391h3.28a3.342,3.342,0,0,0-.4,1.47Zm6.33,19.605a2.331,2.331,0,0,1-4.6,0V23.036h4.6v3.431Zm-6.33-4.411v-1.47c0-1.912,1.784-3.431,4.028-3.431s4.028,1.519,4.028,3.431v1.47H65.207Zm8.114-11.763a3.178,3.178,0,0,1,3.4,2.892V23.477a1.135,1.135,0,0,1-1.208,1.029h-2.82v-1.47h1.151a.508.508,0,0,0,.575-.49V20.586c0-2.451-2.3-4.411-5.179-4.411s-5.179,1.961-5.179,4.411v1.961a.508.508,0,0,0,.575.49h1.151v1.47h-2.82a1.138,1.138,0,0,1-1.208-1.029V13.185a3.181,3.181,0,0,1,3.4-2.892Zm-4.086-.98a2.663,2.663,0,0,1-2.877-2.451,2.914,2.914,0,0,1,5.754,0A2.663,2.663,0,0,1,69.235,9.313ZM76.14,6.47l-2.877.49v-.1a2.721,2.721,0,0,0-.4-1.47h3.28V6.47Zm5.179-4.509h-2.3V.98h2.3Z"
            fill="#0a3256"
            id="svg_9"
            transform="translate(-56 0)"
          />
        </g>
      </g>
    </g>
  </svg>
);
